import { render, staticRenderFns } from "./EmailInput.vue?vue&type=template&id=081eb4a9&"
import script from "./EmailInput.vue?vue&type=script&lang=ts&"
export * from "./EmailInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports